import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { getExtStyles } from "./getExtStyles";
export const ImageContainer = /*#__PURE__*/ memo((param)=>{
    let { className, style, borderRadius, processing, ext, color, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("relative flex h-full grow flex-col items-center justify-center overflow-hidden", processing && "shimmer-background", className),
        style: {
            borderRadius,
            backgroundColor: color === "default" || !ext ? "var(--colors-grey4)" : getExtStyles(ext).bgColor,
            ...style
        },
        ...props
    });
});
ImageContainer.displayName = "ImageContainer";
